import { ApolloError } from 'apollo-client'
import { GraphQLError } from 'graphql'

/**
 * Checks if the ApolloError contains a graphQLError with a specific code.
 */
export function hasGraphQLErrorCode(
  apolloError: ApolloError,
  errorCode: string
): GraphQLError | undefined {
  return apolloError.graphQLErrors.find(
    error => error.extensions?.code === errorCode
  )
}
